// Expediente con acceso directo para solucionar problemas de routing
import DetalleExpediente from './DetalleExpediente';
import { useEffect, useState } from 'react';
import { Box, Center, Spinner, Text, Button, VStack, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Esta es una versión simplificada que verifica la autenticación directamente
// sin depender de ProtectedRoute para romper el ciclo de redirecciones
export default function DirectExpediente() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    // Verificar autenticación directamente del localStorage
    const checkAuth = () => {
      try {
        console.log("DirectExpediente: Verificando autenticación desde localStorage");
        const storedUser = localStorage.getItem('currentUser');
        const authToken = localStorage.getItem('authToken');
        
        if (storedUser && authToken) {
          console.log("DirectExpediente: Usuario encontrado en localStorage");
          setIsAuthenticated(true);
        } else {
          console.log("DirectExpediente: No se encontró usuario en localStorage");
          setIsAuthenticated(false);
          
          // Avisar al usuario
          toast({
            title: 'No has iniciado sesión',
            description: 'Serás redirigido a la página de inicio de sesión',
            status: 'warning',
            duration: 3000,
            isClosable: true,
          });
          
          // Redireccionar después de un breve retraso
          setTimeout(() => {
            navigate('/login');
          }, 1500);
        }
      } catch (error) {
        console.error("Error verificando autenticación:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    // Comprobar después de un breve retraso para evitar condiciones de carrera
    const timeoutId = setTimeout(checkAuth, 500);
    
    return () => clearTimeout(timeoutId);
  }, [navigate, toast]);

  // Mostrar spinner mientras se verifica la autenticación
  if (isLoading) {
    return (
      <Box minH="100vh">
        <Center h="100vh" flexDirection="column">
          <Spinner size="xl" color="red.500" mb={4} />
          <Text color="gray.600">
            Cargando expediente...
          </Text>
        </Center>
      </Box>
    );
  }

  // Si está autenticado, mostrar el detalle de expediente
  if (isAuthenticated) {
    return <DetalleExpediente />;
  }

  // Si no está autenticado pero todavía no se ha redirigido
  return (
    <Box minH="100vh">
      <Center h="100vh" flexDirection="column">
        <VStack spacing={4}>
          <Text fontSize="xl" fontWeight="bold" color="red.500">
            Necesitas iniciar sesión para acceder al expediente
          </Text>
          <Button 
            colorScheme="red" 
            onClick={() => navigate('/login')}
          >
            Ir a la página de inicio de sesión
          </Button>
        </VStack>
      </Center>
    </Box>
  );
}
